<template>
  <div
    class="grid grid-cols-1 md:grid-cols-2 gap-4 my-6"
    aria-label="SSS Soruları"
  >
    <template v-for="(item, index) in props.questions" :key="index">
      <details class="group" aria-label="SSS Soru">
        <summary
          class="flex flex-row items-center justify-between cursor-pointer list-none bg-orange-500 rounded p-3"
          aria-label="SSS Soru Başlık"
        >
          <h4 class="text-white text-sm md:text-base">
            {{ index + 1 < 10 ? '0' : '' }}{{ index + 1 }}. {{ item.header }}
          </h4>
          <Icon
            name="mingcute:down-line"
            class="size-4 text-white transition-transform duration-300 group-open:rotate-180"
          />
        </summary>

        <div
          class="text-xs text-slate-500 mt-2"
          v-html="item.explanation"
          aria-label="SSS Soru Açıklama"
        ></div>
      </details>
    </template>
  </div>
</template>

<script lang="ts" setup>
interface Question {
  header: string
  explanation: string
}

const props = withDefaults(
  defineProps<{
    questions?: Question[]
  }>(),
  {
    questions: () => [],
  },
)
</script>

<style scoped>
.transition-max-height {
  transition: max-height 0.3s ease-in-out;
}
</style>
